import { NavLink } from "react-router-dom"
import { route, publicUrlFor } from "../../../../globals/constants"
import FastImage from "../../../../globals/elements/fastimg"

export default function Service1({ options, data } ) {
    return (
        <div className="section-full  p-t80 p-b50 bg-gray bg-no-repeat bg-cover bg-white" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg15.jpg")})` }}>
                <div className="container">
                    {/* TITLE START*/}
                    <div className="section-head text-center">
                        <h2 data-title="Welcome">{options.title} </h2>
                        <div className="mt-separator-outer">
                            <div className="mt-separator site-bg-primary" />
                        </div>
                    </div>
                    {/* TITLE END*/}
                    <div className="section-content sx-how-it-work">
                        <div className="row">
                            {/* block 1 */}
                            <div className="col-lg-4 col-md-6">
                                <div className="mt-box m-b30">
                                    <div className="mt-icon-box-wraper  p-a30 left bg-white  hover-border-outer hover-border">
                                        <div className="icon-md radius m-b15">
                                            <span className="icon-cell  site-text-primary">
                                                <FastImage src={data?.length > 0 && data[0]?.img.url} />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte  m-b15"><NavLink to={route.pages.ABOUT}>{data?.length > 0 && data[0].title}</NavLink></h4>
                                            <p>{data?.length > 0 && data[0].description}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-box m-b30">
                                    <div className="mt-icon-box-wraper  p-a30 left bg-white  hover-border-outer hover-border">
                                        <div className="icon-md radius m-b15">
                                            <span className="icon-cell  site-text-primary">
                                                <FastImage src={data?.length > 1 && data[1]?.img.url} />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte  m-b15"><NavLink to={route.pages.ABOUT}>{data?.length > 1 && data[1].title}</NavLink></h4>
                                            <p>{data?.length > 0 && data[1].description}.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* block 2 */}
                            <div className="col-lg-4 col-md-6">
                                <div className="mt-box m-b30">
                                    <div className="mt-media mid-img-verticle">
                                        <FastImage src={options?.image} alt="" />
                                    </div>
                                </div>
                            </div>
                            {/* block 3 */}
                            <div className="col-lg-4 col-md-12">
                                <div className="mt-box m-b30">
                                    <div className="mt-icon-box-wraper  p-a30 left bg-white   hover-border-outer hover-border">
                                        <div className="icon-md radius m-b15">
                                            <span className="icon-cell  site-text-primary">
                                                <FastImage src={data?.length > 2 && data[2]?.img.url} />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte  m-b15"><NavLink to={route.pages.ABOUT}>{data?.length > 2 && data[2].title}</NavLink></h4>
                                            <p>{data?.length > 2 && data[2].description}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-box m-b30">
                                    <div className="mt-icon-box-wraper  p-a30 left bg-white   hover-border-outer hover-border">
                                        <div className="icon-md radius m-b15">
                                            <span className="icon-cell  site-text-primary">
                                                <FastImage src={data?.length > 0 && data[3]?.img.url} />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte  m-b15"><NavLink to={route.pages.ABOUT}>{data?.length > 3 && data[3].title}</NavLink></h4>
                                            <p>{data?.length > 3 && data[0].description}.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}